import { Box, Button, Tooltip } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import { useAlertEvents } from "../hooks/query/useAlertEvents";
import { AlertLogViewer } from "../components/LogEventsViewer";
import { useAlert } from "../hooks/query/useAlert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";


export const AlertEventsPage: React.FC = () => {
    const { alertId } = useParams<{ alertId: string }>();
    const {data: events = []} = useAlertEvents(alertId);
    const {data: alert} = useAlert(alertId);

    return <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" justifyContent="end">
            <Tooltip title="This is only for testing purposes, since in prod the events will come from third parties">
                <Button
                    variant="outlined"
                    href={`/alerts/${alertId}?dialog=new-alert-event&alertId=${alertId}`}
                    startIcon={<FontAwesomeIcon icon={faPlus} />}
                >
                    Generate
                </Button>
            </Tooltip>
        </Box>

        <Box width="100%" display="flex" flexDirection="column" justifyContent="space-between" gap={2}>
            {alert && <AlertLogViewer alert={alert} events={events}></AlertLogViewer>}
        </Box>
    </Box>
}